<template>
    <div class="eq5d-wrapper">
        <v-container fill-height>
            <v-layout column>
                <v-snackbar color="error" v-model="wizSnackbarShow" top>
                    {{ wizSnackbarText }}
                    <v-btn text
                           class="white error"
                           @click.native="wizSnackbarShow = false">Close</v-btn>
                </v-snackbar>
                <div v-if="eq5dShowMobile" class="eq5d-wiz-mobile-wrapper">
                    <div v-if="wizCurrentStep < 5"
                         class="eq5d-tablet-screen-title headline text-md-left px-5 py-3"
                         v-html="eq5dInfo.heading">
                    </div>

                    <div>
                        <template v-for="(item, index) in eq5dInfo.mainQuestions">
                            <div class="eq5d-question-wrapper py-4"
                                 :key="index"
                                 v-if="wizStepShow[index]">
                                <div class="eq5d-question-label subtitle-1 mb-4 text-center">
                                    <label :for="`id_${item.dataItemID}_a`"
                                           v-html="item.caption">
                                    </label>
                                </div>
                                <div class="eq5d-question-answer-options px-3">
                                    <answer-options-sm :id="`id_${item.dataItemID}_a`"
                                                       v-model="eq5dData[index]"
                                                       :options="item.options">
                                    </answer-options-sm>
                                </div>
                            </div>
                        </template>
                        <div v-if="wizCurrentStep == 5" class="eq5d-vas-mobile-info" v-html="eq5dInfo.scaleQuestion.caption"></div>

                        <div v-if="wizCurrentStep == 6" class="eq5d-wiz-mobile-vas-wrapper">
                            <div :class="classEq5dVasInstruction"
                                 class="px-3 py-1 text-xs-left"
                                 v-html="eq5dInfo.scaleQuestion.scaleCaptionTop">
                            </div>
                            <visual-analogue-scale v-model="eq5dData[5]"
                                                   :pointerYAdjuster="pointerYAdjusterValue"
                                                   :scaleCaptionLeft="eq5dInfo.scaleQuestion.scaleCaptionLeft">
                            </visual-analogue-scale>
                        </div>

                        <v-footer height="100px" color="primary" fixed app>
                            <v-layout row wrap justify-center>
                                <v-flex xs12 class="eq5d-mobile-nav-wrapper">
                                    <v-btn @click="previousSlide"
                                           class="eq5d-mobile-previous-btn success"
                                           small>
                                        <v-icon left>mdi-chevron-left</v-icon>Previous
                                    </v-btn>

                                    <v-chip class="primary--text subtitle-2">{{ wizCurrentStep + 1 }} of 7</v-chip>

                                    <v-btn @click="nextSlide"
                                           :loading="formSubmitBusy || formSavingBusy"
                                           class="eq5d-mobile-next-btn success"
                                           small>
                                        {{ this.wizCurrentStep == this.getLastStepIdx() ? "Submit" : "Next" }}
                                        <v-icon right>mdi-chevron-right</v-icon>
                                    </v-btn>
                                </v-flex>
                                <v-flex xs12>
                                    <div class="eq5d-copyright primary body-2 white--text px-3 py-1">
                                        &copy; EuroQol Research Foundation. EQ-5D&trade; is a trade
                                        mark of the EuroQol Research Foundation
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-footer>
                    </div>
                </div>
                <div v-if="!eq5dShowMobile" class="eq5d-wiz-tablet-wrapper">
                    <div>
                        <div v-if="wizCurrentStep < 5"
                             class="eq5d-tablet-screen-title headline text-md-left px-5 py-3"
                             v-html="eq5dInfo.heading">
                        </div>

                        <template v-for="(item, index) in eq5dInfo.mainQuestions">
                            <div class="eq5d-question-wrapper-tablet px-5 py-3"
                                 :key="index"
                                 v-if="wizStepShow[index]">
                                <div class="eq5d-question-label-tablet title mb-1">
                                    <label v-html="item.caption"></label>
                                </div>
                                <div class="eq5d-question-answer-options-tablet">
                                    <v-radio-group v-model="eq5dData[index]" :mandatory="false">
                                        <v-radio v-for="(option, index) in item.options"
                                                 :key="index"
                                                 :value="option.value"
                                                 color="grey darken-3">
                                            <div v-html="option.text" slot="label"></div>
                                        </v-radio>
                                    </v-radio-group>
                                </div>
                            </div>
                        </template>
                        <div class="eq5d-vas-tablet-wrapper" v-if="wizCurrentStep == 5">
                            <div class="eq5d-vas-tablet-info" v-html="eq5dInfo.scaleQuestion.caption"></div>
                            <div class="eq5d-vas-tablet-device">
                                <visual-analogue-scale v-model="eq5dData[5]"
                                                       :pointerYAdjuster="pointerYAdjusterValue"
                                                       :scaleCaptionLeft="eq5dInfo.scaleQuestion.scaleCaptionLeft">
                                </visual-analogue-scale>
                            </div>
                        </div>

                        <v-footer height="100px" color="primary" fixed inset app>
                            <v-layout row wrap justify-center>
                                <v-flex xs12 class="eq5d-tablet-nav-wrapper">
                                    <v-btn @click="previousSlide"
                                           class="eq5d-tablet-previous-btn success"
                                           small>
                                        <v-icon left>mdi-chevron-left</v-icon>Previous
                                    </v-btn>

                                    <v-chip class="primary--text subtitle-1">{{ wizCurrentStep + 1 }} of 6</v-chip>

                                    <v-btn @click="nextSlide"
                                           :loading="formSubmitBusy || formSavingBusy"
                                           class="eq5d-tablet-next-btn success"
                                           small>
                                        {{ this.wizCurrentStep == this.getLastStepIdx() ? "Submit" : "Next" }}
                                        <v-icon right>mdi-chevron-right</v-icon>
                                    </v-btn>
                                </v-flex>
                                <v-flex xs12>
                                    <div class="eq5d-copyright primary white--text px-3 py-1">
                                        &copy; EuroQol Research Foundation. EQ-5D&trade; is a trade
                                        mark of the EuroQol Research Foundation
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-footer>
                    </div>
                </div>
            </v-layout>
        </v-container>
        <v-dialog v-model="formSubmitBusy" persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    {{ formSubmitBusyText }}
                    <v-progress-linear indeterminate
                                       color="white"
                                       class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dlgInfo" persistent max-width="600px">
            <v-card>
                <v-card-title class="justify-center primary">
                    <span class="headline text-center white--text">INFORMATION</span>
                </v-card-title>
                <v-card-text class="text-center pt-4">
                    <span class="subtitle-1 dynamic-crf-info-dialog-text">
                        {{
            dlgMessage
                        }}
                    </span>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn @click="closeInfoDialog"
                           :loading="formRedirectBusy"
                           class="primary mb-2"
                           width="100"
                           large>OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar :value="getStepNotSavedMsg"
                    @input="setStepNotSavedMsg(false)"
                    color="error"
                    :timeout="10000"
                    top>
            <div>
                Form contains unsaved data, please click NEXT button to save your
                changes.
            </div>
            <v-btn text class="white error" @click.native="setStepNotSavedMsg(false)">Close</v-btn>
        </v-snackbar>
    </div>
</template>
<script>
    /* eslint-disable */

    import axios from "axios";
    import { mapMutations, mapGetters } from "vuex";

    import { trialResourceAccount, eq5dInfoMap, getEndOfFormDialogHtml } from "./DynamicCRF-generated.js";

    import { crfCallbacks } from '../handcrafted/CrfCallbacks';

    export default {
        props: {
            crfId: { Type: String, required: true },
        },
        data() {
            let eq5dInfo = eq5dInfoMap[this.crfId];

            eq5dInfo.dataItemKeys = eq5dInfo.mainQuestions
                .map(q => q.dataItemID)
                .concat([
                    eq5dInfo.scaleQuestion.dataItemID,
                    eq5dInfo.timePointDataItemID,
                    this.crfId
                ]);

            return {
                eq5dInfo,

                wizStart: false,
                wizStartTablet: false,
                wizSnackbarShow: false,
                wizSnackbarText: "Please answer this question",
                formSubmitBusy: false,
                formRedirectBusy: false,
                formSubmitBusyText: "",
                formSavingBusy: false,
                formCompleteness: "",
                eq5dShowMobile: false,
                dlgInfo: false,
                dlgInfoOrigion: "",
                dlgMessage: "",
                eq5dFormValid: false,
                wizCurrentStep: 0,
                wizStepShow: [true, false, false, false, false, false, false],

                baseUrl: "api/DynamicCrf/",

                eq5dData: [null, null, null, null, null, null],
            };
        },
        watch: {
            eq5dData: {
                handler: function () {
                    this.setFormHasUnsavedChanges(true);
                },
                deep: true,
            },
        },
        methods: {
            ...mapMutations([
                "setCurrentRoutePath",
                "setFormCompleteness",
                "setFormHasUnsavedChanges",
                "setStepNotSavedMsg",
                "setDefaultPage",
                "resetDataEntry"
            ]),
            setViewType: function () {
                if (this.$vuetify.breakpoint.smAndDown) {
                    this.eq5dShowMobile = true;
                } else {
                    this.eq5dShowMobile = false;
                }
            },
            getCurrentMode: function () {
                return this.eq5dShowMobile ? 'mobile' : 'tablet';
            },
            getLastStepIdx: function () {
                return this.eq5dShowMobile ? 6 : 5;
            },
            setCurrentStep: function (step_idx) {
                this.$set(this.wizStepShow, this.wizCurrentStep, false);
                this.wizCurrentStep = step_idx;
                this.$set(this.wizStepShow, this.wizCurrentStep, true);
            },
            getDataTableID: function () {
                return this.eq5dInfo.dataItemKeys[7];
            },
            goToURL(crf_url, default_page) {
                this.setDefaultPage(default_page);
                this.$router.push(crf_url);
            },
            nextSlide: async function () {
                let self = this;
                function isMissingAnswer(data_idx) {
                    return self.eq5dData[data_idx] != 0 && !self.eq5dData[data_idx];
                }
                function pageContainsMissingData() {
                    if (self.eq5dShowMobile) {
                        return (
                            self.wizCurrentStep < 5 && isMissingAnswer(self.wizCurrentStep) ||
                            self.wizCurrentStep == 6 && isMissingAnswer(5)
                        );
                    } else {
                        return isMissingAnswer(self.wizCurrentStep);
                    }
                }

                this.calculateFormCompleteness();

                if (this.eq5dInfo.allQuestionsRequired && pageContainsMissingData()) {
                    this.wizSnackbarShow = true;
                    return;
                }

                if (!await this.saveFormData())
                    return;

                if (this.wizCurrentStep == this.getLastStepIdx()) {
                    let dataTableID = this.getDataTableID();
                    let dlg_content = getEndOfFormDialogHtml.call(this);
                    if (dlg_content) {
                        this.showDialog(dlg_content, null);
                    } else if (crfCallbacks[dataTableID] && crfCallbacks[dataTableID].onSubmit) {
                        await crfCallbacks[dataTableID].onSubmit.call(this);
                    } else {
                        this.formRedirectBusy = true;
                        this.goToURL(this.getNextCrfUrl, 'first');
                    }
                } else {
                    this.setCurrentStep(this.wizCurrentStep + 1);
                }
            },
            previousSlide: function () {
                if (this.getFormHasUnsavedChanges) {
                    this.setStepNotSavedMsg(true);
                    return;
                }

                if (this.wizCurrentStep > 0) {
                    this.setCurrentStep(this.wizCurrentStep - 1);
                } else {
                    this.goToURL(this.getPrevCrfUrl, 'last');
                }
            },
            saveFormData: async function () {
                if (this.wizCurrentStep == this.getLastStepIdx() - 1) {
                    this.formSubmitBusyText = "Please wait, saving form data";
                    this.formSubmitBusy = true;
                }

                this.formSavingBusy = true;

                let dataItemKeys = this.eq5dInfo.dataItemKeys;

                //prepare sData (source data)
                let sData = {
                    guid: this.getFormGuid,
                    tableName: dataItemKeys[7],
                    timePointDataItem: dataItemKeys[6],
                    pin: this.getDataEntryPin,
                    dataItems: [],
                    sessionRestoreInfo: JSON.stringify({
                        lastEditedURL: this.$route.path,
                        lastEditedItem: "", //ignored for eq5d
                    }),
                };

                for (let i = 0; i < this.eq5dData.length; i++) {
                    sData.dataItems.push({
                        dataItemId: dataItemKeys[i],
                        dataItemValue: this.eq5dData[i],
                    });
                }
                this.dlgInfoOrigion = "form-data-saved";
                let actionUrl = `${this.baseUrl}SaveFormData`;
                let rData = null;

                try {
                    rData = await axios.post(actionUrl, sData);
                    this.setFormHasUnsavedChanges(false);
                } catch (error) {
                    this.dlgMessage = `Sorry, we are having some technical issues. Please email ${trialResourceAccount} quoting error description: ${this.eq5dInfo.crfTitle.toUpperCase()}-FAILED-TO-SAVE`;
                    this.dlgInfo = true;
                    return false;
                } finally {
                    this.formSubmitBusy = false;
                    this.formSavingBusy = false;
                }               

                if (rData.data === -6) {//PIN has expired
                    this.resetDataEntry();
                    return this.$router.push("/session-expired-message");
                }

                return true;
            },
            setFormData: async function () {
                let dataItemKeys = this.eq5dInfo.dataItemKeys;

                this.formSubmitBusyText = "Please wait, loading form data";
                this.formSubmitBusy = true;

                //prepare sData (source data)
                let sData = {
                    pin: this.getDataEntryPin,
                    guid: this.getFormGuid,
                    tableName: dataItemKeys[7],
                    timePointDataItem: dataItemKeys[6],
                    dataItems: [],
                };

                this.dlgInfoOrigion = "form-data-loading";
                let actionUrl = `${this.baseUrl}GetFormData`;
                let rData = null;

                try {
                    rData = await axios.post(actionUrl, sData);
                } catch (error) {
                    this.dlgMessage = `Sorry, we are having some technical issues. Please email ${trialResourceAccount} quoting error description: ${this.crfs[
                        this.crfId
                    ].crfTitle.toUpperCase()}-FAILED-TO-INITIALISE-FORM`;
                    this.dlgInfo = true;
                    return;
                }

                let rDataItems = rData.data;

                dataItemKeys.slice(0, 6).forEach((dataItemID, idx) => {
                    if (rDataItems[dataItemID] != undefined) {
                        this.$set(
                            this.eq5dData,
                            idx,
                            rDataItems[dataItemID] === "" ? null : rDataItems[dataItemID]
                        )
                    }
                })
                this.formSubmitBusy = false;
            },
            closeInfoDialog: function () {
                if (this.dlgInfoOrigion == "form-data-saved") {
                    this.formRedirectBusy = true;
                    this.$router.push(this.getNextCrfUrl);
                }
            },
            submitEq5dData: function () {
                if (this.eq5dData[5] == null && this.eq5dInfo.allQuestionsRequired) {
                    this.wizSnackbarText = "Please answer all questions";
                    this.wizSnackbarShow = true;
                    return;
                }
            },
            calculateFormCompleteness: function () {
                let qCount = 6,
                    vCount = 0;
                for (let i = 0; i < this.eq5dData.length; i++) {
                    if (this.eq5dData[i] || this.eq5dData[i] === 0) {
                        vCount++;
                    }
                }
                this.formCompleteness = `${Math.round((vCount / qCount) * 100)}%`;
                this.setFormCompleteness(this.formCompleteness);
            },
        },
        computed: {
            ...mapGetters([
                "getFormGuid",
                "getFormAuthenticated",
                "getNextCrfUrl",
                "getPrevCrfUrl",
                "getDataEntryPin",
                "getFormHasUnsavedChanges",
                "getStepNotSavedMsg",
                "getMenuItems",
                "getDefaultPage"
            ]),
            eq5dPromptText: function () {
                if (this.eq5dVersion == "eq5d3l" || this.eq5dVersion == "eq5d5l") {
                    return "scale";
                } else {
                    return "line";
                }
            },
            eq5dPromptText2: function () {
                if (this.eq5dVersion == "eq5dyp") {
                    return "your child's";
                } else {
                    return "your";
                }
            },
            pointerYAdjusterValue: function () {
                if (this.$vuetify.breakpoint.xs) {
                    return 8;
                } else if (this.$vuetify.breakpoint.smAndDown) {
                    return 8;
                }
                return -2;
            },
            classEq5dVasInstruction: function () {
                return {
                    "eq5d-vas-instruction-sm": this.$vuetify.breakpoint.xs,
                    "eq5d-vas-instruction-md": this.$vuetify.breakpoint.sm,
                    "eq5d-vas-instruction-lg": this.$vuetify.breakpoint.mdAndUp,
                };
            },
        },
        async mounted() {
            this.$store.commit("setCrfTitle", this.eq5dInfo.crfTitle);
            this.setCurrentRoutePath(this.$route.path);
            this.setViewType();
            await this.setFormData();
            this.calculateFormCompleteness();
            this.setFormHasUnsavedChanges(false);

            this.setDefaultPage('first');
        },
    };
</script>
<style>
    .eq5d-header-toolbar .v-toolbar__content,
    .v-toolbar__extension {
        justify-content: center;
    }

    .eq5d-question-answer-options {
        display: flex;
        flex-direction: row;
        justify-content: center;
    }

    .eq5d-intro {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 400px;
    }

    .eq5d-large-screen-title {
        text-align: center;
    }

    .eq5d-question-wrapper-bg {
        display: flex;
        flex-direction: column;
    }

    .eq5d-question-label {
        padding-left: 10px;
        padding-right: 10px;
        color: #424040;
        font-size: 16px;
        font-weight: 700;
    }

    .eq5d-question-label-bg {
        flex: 1 1 auto;
        color: #424040;
    }

    .eq5d-question-answer-options-bg {
        flex: 1 1 auto;
    }

    .eq5d-question-answer-options-style {
        text-decoration: underline;
        padding: 0 3px;
    }

    .eq5d-question-custom-style {
        font-weight: 300;
        font-style: italic;
    }

    .eq5d-vas-lg-wrapper {
        margin-left: auto;
        margin-right: auto;
    }

    .eq5d-vas-lg-device {
        display: inline-block;
    }

    .eq5d-vas-lg-info {
        display: inline-block;
        padding-right: 20px;
        padding-left: 20px;
        padding-top: 20px;
        vertical-align: top;
    }

        .eq5d-vas-lg-info ul li {
            margin-bottom: 15px !important;
            font-size: 18px;
        }

    .eq5d-vas-mobile-info {
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 50px;
    }

        .eq5d-vas-mobile-info ul {
            list-style-type: none;
            display: inline-block;
        }

            .eq5d-vas-mobile-info ul li {
                margin-bottom: 15px !important;
                font-size: 18px;
            }

    .eq5d-wrapper {
        height: 100%;
    }

    .eq5d-wiz-mobile-wrapper {
        height: 100%;
    }

    .eq5d-wiz-mobile-vas-wrapper {
        height: 100%;
    }

    .eq5d-wrapper .container {
        padding: 0;
    }

    .eq5d-copyright {
        font-style: italic;
        text-align: center;
    }

    .eq5d-mobile-nav-wrapper {
        display: flex;
        justify-content: space-between;
    }

    .eq5d-bg-nav-wrapper {
        display: flex;
        justify-content: space-between;
    }

    .eq5d-question-answer-options-bg .theme--light.v-label {
        color: #424242;
    }

    @media only screen and (min-width: 960px) {
        .eq5d-wrapper .container {
            max-width: none;
        }
    }

    .eq5d-question-wrapper-tablet {
        display: flex;
        flex-direction: column;
    }

    .eq5d-tablet-screen-title {
        text-align: left;
    }

    .eq5d-question-label-tablet {
        flex: 1 1 auto;
        color: #424040;
        font-size: 16px;
        font-weight: 700;
    }

    .eq5d-question-answer-options-tablet {
        flex: 1 1 auto;
    }

    .eq5d-vas-tablet-wrapper {
        margin-left: auto;
        margin-right: auto;
    }

    .eq5d-vas-tablet-info {
        display: inline-block;
        max-width: 500px;
        padding-top: 20px;
        padding-right: 20px;
        padding-left: 10px;
        vertical-align: top;
    }

    .eq5d-vas-tablet-device {
        display: inline-block;
    }

    .eq5d-tablet-nav-wrapper {
        display: flex;
        justify-content: space-between;
    }

    .eq5d-section-wrapper-large {
        max-width: 1100px;
        width: 80vw;
        margin: 0 auto;
    }

    .eq5d-question-answer-options-tablet .theme--light.v-label {
        color: #424242;
    }

    .eq5d-vas-tablet-info ul li {
        line-height: 2em;
    }

    .eq5d-vas-instruction-sm {
        font-size: 16px;
        font-weight: bold;
    }

    .eq5d-vas-instruction-md {
        font-size: 18px;
        font-weight: bold;
    }

    .eq5d-vas-instruction-lg {
        font-size: 20px;
        font-weight: bold;
    }
</style>
